import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'

class ListWorkOrders extends Component {
  getColumns = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/work-orders/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Number',
        dataIndex: 'number'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { workOrders } = this.props

    const data = workOrders.map((workOrders, index) => {
      // format date from db
      workOrders.created_date = moment(new Date(workOrders.created_date)).format('YYYY-MM-DD')
      const returnObj = Object.assign(
        {
          key: `${workOrders.id}${index}`,
          job: {
            job_id: workOrders.job_id,
            job_type: workOrders.job_type,
            id: workOrders.id
          }
        },
        workOrders
      )
      return returnObj
    })
    return data
  }

  render() {
    return (
      <div>
        <h6>Work Orders</h6>
        <Table
          pagination={false}
          columns={this.getColumns()}
          dataSource={this.getData()}
          size="small"
          style={{ backgroundColor: 'white' }}
        />
      </div>
    )
  }
}

export default ListWorkOrders



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListWorkOrders.js